import React from 'react'
import '.././PopupCommonStyle.css'
import styles from './Style.module.css'
import { BtnPrimary } from '../../Buttons/BtnPrimary';
import { BtnSecondary } from '../../Buttons/BtnSecondary';

export const LeaveBookingPopup = ({
  active,
  onClose,
  handleDeleteBooking,
}) => {
  return (
    <div className={`${styles.leaveBookingPopup} popup ${active ? "show" : ""}`}>
        <div className={`${styles.popHeader} popup-header`}>
          <h2 className="title">Leave Booking?</h2>
          <h6 className="titleSub">Going back will release your reserved appointment.</h6> 
          <h6 className="titleSub">Your selected time slot may no longer be available if you continue with the booking later.</h6>
        </div>
        <div className={`popup-body`}></div>

        <div className={`${styles.footer} popup-footer`}>
          <BtnSecondary
            label="Leave Booking"
            handleClick={handleDeleteBooking}
            customClass="w-100 no-icon"
          />
          <BtnPrimary 
            label="Continue Booking" 
            handleClick={onClose} 
            customClass="w-100 no-icon"
          />
        </div>
    </div>
  )
}
